/* @flow */
import * as React from 'react';

import './divider.module.css';

type Props = {
    text?: string,
    darkText?: boolean,
    isDisabled?: boolean,
};

export class Line extends React.PureComponent<Props> {
    render() {
        return (
            <div styleName={this.props.isDisabled ? 'container--disabled' : 'container'}>
                <div styleName='divider-line' />
                {this.props.text ? (
                    <div styleName={this.props.darkText ? 'divider-text--dark' : 'divider-text'}>
                        {this.props.text}
                    </div>
                ) : undefined}
                <div styleName='divider-line' />
            </div>
        );
    }
}
